/** Vite eager-glob module shape — either a bare URL string or an ES module with a default export. */
export type EagerModule = { default?: string } | string;

/**
 * Turns a Vite eager-glob map into a flat { stem → url } registry.
 * Pass cdnBase to produce CDN URLs; omit it for local bundled URLs.
 *
 * import.meta.glob() must stay in each caller — Vite resolves globs
 * statically relative to the file they're written in.
 */
export function buildRegistry(
  imageMap: Record<string, EagerModule>,
  cdnBase?: string
): Record<string, string> {
  const images: Record<string, string> = {};

  for (const path in imageMap) {
    const filename = path.split('/').pop() || path;
    const key = filename.replace(/\.\w+$/, '');

    if (cdnBase) {
      images[key] = `${cdnBase}/${filename}`;
    } else {
      const entry = imageMap[path];
      images[key] = typeof entry === 'string' ? entry : (entry.default ?? '');
    }
  }

  return images;
}
